import { render, staticRenderFns } from "./WindowManager.vue?vue&type=template&id=1d6320c5&scoped=true&"
import script from "./WindowManager.vue?vue&type=script&lang=js&"
export * from "./WindowManager.vue?vue&type=script&lang=js&"
import style0 from "./WindowManager.vue?vue&type=style&index=0&id=1d6320c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6320c5",
  null
  
)

export default component.exports